import * as React from "react";
import { SVGProps } from "react";
export function CircleClockIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#circle-clock_svg__a)"
        stroke="#000"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12.002 23.143c6.154 0 11.143-4.989 11.143-11.143 0-6.154-4.989-11.143-11.143-11.143C5.848.857.86 5.846.86 12c0 6.154 4.99 11.143 11.143 11.143Z" />
        <path d="M12 7.714V12l4.354 5.074" />
      </g>
      <defs>
        <clipPath id="circle-clock_svg__a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
